import { render, staticRenderFns } from "./GeofenceMonitor.vue?vue&type=template&id=8b61e3bc&"
import script from "./GeofenceMonitor.vue?vue&type=script&lang=ts&"
export * from "./GeofenceMonitor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports